module.exports = __webpack_public_path__ + "img/all-workflows.17ffe7cf.svg";